import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouterConstants } from './core/constants/router.constants';
import { AuthGuardService } from './core/services/auth-guard.service';
import { LayoutsComponent } from './layouts/layouts.component';
import { SpocOnCallBookingComponent } from './spoc-approval-email/spoc-on-call-booking/spoc-on-call-booking.component';

const routes: Routes = [
  { path: RouterConstants.default, redirectTo: '/' + RouterConstants.auth + '/' + RouterConstants.client, pathMatch: 'full' },
  { path: RouterConstants.auth, loadChildren: () => import('./auth/auth.module').then(mod => mod.AuthModule) },
  { path: RouterConstants.sso, loadChildren: () => import('./sso/sso.module').then(mod => mod.SsoModule) },
  { path: RouterConstants.default, redirectTo: '/' + RouterConstants.layoutContainer + '/' + RouterConstants.userProfile.default, pathMatch: 'full' },
  { path: RouterConstants.newRegister, loadChildren: () => import('./new-registration/new-registration.module').then(mod => mod.NewRegistrationModule) },
  {
    path: RouterConstants.layoutContainer, component: LayoutsComponent, canActivate: [AuthGuardService],
    children: [
      { path: RouterConstants.default, redirectTo: RouterConstants.userProfile.default, pathMatch: "full" },
      { path: RouterConstants.userProfile.default, loadChildren: () => import('./pages/pages.module').then(mod => mod.PagesModule) },
      { path: RouterConstants.chat, loadChildren: () => import('./layouts/topbar/chat/chat-routing.module').then((mod) => mod.ChatRoutingModule) },

    ]
  },
  { path: RouterConstants.dashboardEmail.baseUrl, loadChildren: () => import('./dashboard-email/dashboard.module').then((mod) => mod.DashboardModule) },
  { path: RouterConstants.spocOnCallEmail.baseUrl, loadChildren: () => import('./spoc-approval-email/spoc-approval-email.module').then((mod) => mod.SpocApprovalEmailModule) },
  { path: RouterConstants.liveTrackingEmail.baseUrl, loadChildren: () => import('./livetracking-email/livetracking-email.module').then((mod) => mod.LivetrackingEmailModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
